//HOW TO ADD A NEW LOC CONTEXT: https://utvikling-secure.webtemp.no/app/9100/TechDoc?project=cv-portal%202.0&folder=frontend

export enum LocContext {
  JOBS = "JOBS",
  JOB = "JOB",
  GENERAL = "GENERAL",
  PROFILE = "PROFILE",
  CV = "CV",
  ADMIN = "ADMIN",
  WORKSCHEDULE = "WORKSCHEDULE",
  TIMESHEETS = "TIMESHEETS",
  MESSAGES = "MESSAGES",
  PRIME = "PRIME",
  PRIVACY = "PRIVACY",
  ERROR = "ERROR",
  TYPES = "TYPES",
  "[Translations no longer in use]" = "[Translations no longer in use]",
}
